import { searchVariations } from './searchVariations';

export const isValidVariation = (
  formRef: any,
  variations: any,
  option: any,
  key: any,
) => {
  if (formRef.current) {
    //BUSCAMOS LAS VARIACIONES QUE COINCIDEN CON LOS DATOS QUE HAY EN EL FORMULARIO
    const vari = searchVariations(variations, formRef?.current?.values, key);

    //TENEMOS TODAS LAS VARIACIONES QUE COINCIDEN CON EL FORM
    //ENTRE LAS VARIACIONES DISPONIBLES, BUSCAMOS LAS QUE TENGAN EL ATRIBUTO Y EL VALOR PASADO A LA VALIDACION
    let foundOption = false;
    vari.forEach((availableVariations: any) => {
      availableVariations.node.attributes.nodes.forEach((av: any) => {
        if (
          av.name === key &&
          av.value.toLowerCase() === option.toLowerCase()
        ) {
          foundOption = true;
        }
      });
    });

    return foundOption;
  }
};
